import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { PayoutRateStoreModel } from './payout-rates.model';

export interface PayoutRateState extends EntityState<PayoutRateStoreModel> {}

@Injectable({
  providedIn: 'root',
})
export class PayoutRateStore extends EntityStore<PayoutRateState, PayoutRateStoreModel, 'id'> {
  constructor() {
    super({
      name: 'payout-rates',
      idKey: 'id',
      initialPropsState: {},
    });
  }
}
